type Props = {
  title: string;
  subtitle: string;
  videoUrl: string;
};

export default function B12VideoBlock({ title, subtitle, videoUrl }: Props) {
  return (
    <section className="bg-gray-100 pt-16 pb-28">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mx-auto max-w-[780px] self-center text-center">
          <h1 className="text-r-5xl my-8 font-bold">{title}</h1>
          <p className="text-r-lg mb-12">{subtitle}</p>
        </div>
        <div className="mx-auto max-w-[890px]">
          <div className="relative w-full overflow-hidden rounded-xl bg-gray-200 after:block after:pt-[56.25%] after:content-['']">
            <iframe
              className="absolute top-0 left-0 h-full w-full"
              src={videoUrl}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              referrerPolicy="origin"
              title="Video player"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
